import React from 'react';
import { Avatar } from '../../components';
import './message-card.scss';
import { useRenderTemplateUi } from '@zonofi/common/hooks/render-template-ui';
import {
  ConversationMessageProps,
  useGetConversationMessage,
} from '../hooks/get-conversation-message';
import { SVGS } from '../../assets';
import { TemplateComponents } from './template-component-ui';

export const MessageCard: React.FC<ConversationMessageProps> = (props) => {
  const { stats, isInternalNote } = props;
  const {
    userId,
    userName,
    msgTime,
    isWhatsapp,
    template,
    msgId,
    generateFileUrlPayload,
    msgType,
  } = useGetConversationMessage(props);
  const renderedComponents = useRenderTemplateUi({
    messageId: msgId,
    template,
    templateUI: TemplateComponents,
    generateFileUrlPayload,
    msgType,
  });
  return (
    <div className="message-with-avatar">
      <div
        className={`message-card font-regular ${
          stats && stats?.error ? 'error' : ''
        } ${isInternalNote ? 'internal_note' : ''}`}
      >
        <div className="msg-avatar">
          {isWhatsapp ? (
            <img src={SVGS.Whatsapp} alt="wa-msg" height={40} width={40} />
          ) : (
            <Avatar id={userId} title={userName} />
          )}
        </div>
        <div className="msg-contents">
          <div className="msg-contents-header">
            <span className="msg-contents-header-name font-semibold">
              {userName}
              {isWhatsapp && <div className="customer-tag">{'Customer'}</div>}
              {isInternalNote && (
                <div className="internal-note">{'Internal Note'}</div>
              )}
            </span>
            <span className="msg-contents-header-time font-regular">
              {msgTime}
            </span>
          </div>
          {renderedComponents}
          {stats && stats?.error && (
            <div className="msg-contents-error">
              <img
                src={SVGS.ErrorInfo}
                width={16}
                height={16}
                alt="failed to send info icon"
                className="message-contents-error-icon"
              />
              <span className="msg-contents-error-description font-regular">
                <span className="font-semibold">Message failed to send :</span>{' '}
                {stats?.error?.description}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
